import axios from 'axios';
import type { AuthUser } from '../auth/AuthContext';

type LoginResponse = {
  access_token: string;
  user: AuthUser;
};

type SignupResponse = {
  user: AuthUser;
};

const API_URL =
  process.env.AUTH_API_URL || "https://centralauthdev.vag.org.np"

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export async function login(args: { email: string; password: string }) {
  const res = await api.post<LoginResponse>('/auth/login', args);
  return res.data;
}

export async function signup(args: {
  email: string;
  password: string;
  username: string;
}) {
  const res = await api.post<SignupResponse>('/auth/signup', args);
  return res.data;
}

